import { Box } from '@mantine/core';
import styles from './HitSlop.module.css';

type HitSlopAmount = number | { top?: number; right?: number; bottom?: number; left?: number };

type HitSlopOwnProps = {
  amount?: HitSlopAmount;
  cursor?: React.CSSProperties['cursor'];
  zIndex?: number;
};

type HitSlopProps<C extends React.ElementType = 'div'> = HitSlopOwnProps &
  React.ComponentPropsWithoutRef<C> & {
    component?: C;
    children?: React.ReactNode;
    ref?: React.Ref<Element>;
  };

export function HitSlop<C extends React.ElementType = 'div'>({
  amount = 0,
  cursor,
  zIndex,
  component,
  children,
  style,
  className,
  ref,
  ...props
}: HitSlopProps<C>) {
  const Component = (component || Box) as React.ElementType;

  const slop =
    typeof amount === 'number'
      ? { top: amount, right: amount, bottom: amount, left: amount }
      : { top: 0, right: 0, bottom: 0, left: 0, ...amount };

  const cssVars = {
    '--hitslop-top': slop.top,
    '--hitslop-right': slop.right,
    '--hitslop-bottom': slop.bottom,
    '--hitslop-left': slop.left,
    '--hitslop-cursor': cursor,
    '--hitslop-zindex': zIndex,
  } as React.CSSProperties;

  return (
    <Component
      ref={ref}
      className={`${styles.hitSlop}${className ? ` ${className}` : ''}`}
      style={{ ...cssVars, ...style }}
      {...props}
    >
      {children}
    </Component>
  );
}
